import React, { useState, useEffect } from 'react';
import { Form, FormGroup, Label, Input, Button, Container, Row, Col } from 'reactstrap';

const CustomerSearch = ({ email: emailProp = '', onButtonClick }) => {
  const [email, setEmail] = useState(emailProp);

  useEffect(() => setEmail(emailProp), [emailProp]);

  const handleClick = (e) => {
    e.preventDefault();
    if (emailProp !== email) {
      onButtonClick(email);
    }
  };

  return (
    <Form onSubmit={handleClick}>
      <FormGroup>
        <Label>Email</Label>
        <Container>
          <Row>
            <Col>
              <Input
                type="email"
                placeholder="Email du client"
                value={email}
                onChange={({ target: { value } }) => setEmail(value.toLowerCase())}
              />
            </Col>
            <Col>
              <Button
                type="submit"
                color="primary"
              >
                Valider
              </Button>
            </Col>
          </Row>
        </Container>
      </FormGroup>
    </Form>
  );
};

export { CustomerSearch };



// WEBPACK FOOTER //
// ./src/components/sav-lovebox/form/customer-search.js